import { createRouter, createWebHistory } from 'vue-router'
import authRoutes from "../domain/auth/routes";
import formRoutes from "../domain/customerForm/routes";

import { useAuthStore } from '../domain/auth/store'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
      ...authRoutes,
      ...formRoutes,
  ]
})

router.beforeEach((to) => {
  // ✅ This will work because the router starts its navigation after
  // the router is installed and pinia will be installed too
  const store = useAuthStore()

  let urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('jwt'))
        store.setJwt(urlParams.get('jwt'))

  if (to.meta.requiresAuth && !store.isLoggedIn) return { name: 'no-token' }
})

export default router
